import { Image, Link } from "components/base";
import { Container, ContainerFluid, Flex } from "components/base/container";
import { ModalParent } from "components/modal";
import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useWallet } from "@manahippo/aptos-wallet-adapter";
import { NormalBtn } from "components/element/element.button";

const SetupStakingPage = () => {
  const navigate = useNavigate();
  const { connected } = useWallet();
  useEffect(() => {
    if (connected) {
      navigate("/setup_detail");
    }
  }, [connected]);

  return (
    <>
      <ContainerFluid>
        <Container col alignCenter py={["60px", "60px", "80px", "100px"]}>
          <Flex col alignCenter width={["100%", "100%", "91%", "83%"]} bg={"normal"} p={"24px 34px"} borderRadius={"24px"} textAlign={"center"}>
            <Flex
              width={["100%", "100%", "91%", "83%"]}
              color={"white"}
              fontWeight={"400"}
              fontSize={["42px", "42px", "45px", "48px"]}
              lineHeight={"100%"}
            >
              Kickstart your staking project by connecting your wallet
            </Flex>
            <Flex mt={["42px", "42px", "57px", "72px"]} fontWeight={"400"} fontSize={["18px", "18px", "20px", "22px"]} lineHeight={"130%"}>
              Are you running into trouble or have any questions, please join us in Discord and let us know!
            </Flex>
            <NormalBtn mt={["30px", "30px", "40px", "50px"]} border={"none"} color={"white"} onClick={() => navigate("/wallet_connect")}>
              Select Wallet
            </NormalBtn>
          </Flex>
        </Container>
      </ContainerFluid>
    </>
  );
};

export default SetupStakingPage;
